import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import moment from "moment";
import { language, translate } from "../../../../../_helpers/general.helper";
import { applyNowIcon } from "./styles";
import { unitIconLight, virtualIconLight, unitMapIconLight } from "./styles";
import Carousel from "react-multi-carousel";
import EngrainMap from "../../../Utility/EngrainMap/EngrainMap";

const tabs = {
  unitList: "unitList",
  unitMap: "unitMap",
  virtualTour: "virtualTour",
};

const UnitInfoWrapper = styled.div`
  &.show-content {
    flex-direction: column;
    align-items: start;
    position: fixed;
    bottom: 135px;
    width: 100%;
    left: -1px;
    overflow: hidden;
    /* background-color: white; */
    z-index: 10;
    height: 100%;

    .info-container {
      display: flex;
      justify-content: space-between;
      padding-top: 0px;
      width: 100%;
      background-color: white;
      padding-bottom: 14px;
      padding-top: 30px;

      .leftInfo {
        display: flex;
        flex-direction: column;
        align-items: start;
        margin-top: 10px;
        margin-left: 35px;
      }

      .rightInfo {
        margin-right: 35px;
        display: flex;
        flex-direction: column;
        align-items: end;

        .likeHeart {
          cursor: pointer;
          height:28px;
          margin-bottom: 5px;
        }
      }

      .info-date {
        color: var(--Secondary-Gray2, #6c757d);
        font-family: "DM Sans";
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 5px;
      } 



      .unit-name {
        color: var(--Primary-DarkBlue, #0f0538);
        font-family: "DM Sans";
        font-size: 20px;
        font-weight: 700;
        text-transform: capitalize;
        margin-bottom: 5px;
      }

      .floor {
        color: #6c757d;
        font-family: "DM Sans";
        font-size: 12px;
        font-weight: 500;
        margin-left: 10px;
        text-transform: lowercase;
      }

      .unit-price {
        color: #0f0538;
        font-family: "DM Sans";
        font-size: 20px;
        font-weight: 700;
        .month {
          color: #414b64;
          font-size: 11px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-left: 5px;
        }
      }
    }

    .apply-wrapper {
      display: flex;
      justify-content: flex-end;
      color: #6c757d;
      font-family: "DM Sans";
      font-size: 15px;
      font-weight: 500;
      width: 100%;
      background-color: white;
      padding: 0 15px 25px 15px;
      height: 56px;
      img {
        margin-right: 5px;
      }

      svg {
        margin-left: 5px;
        margin-bottom: 5px;
      }

      .unit-map-button {
        padding: 6px 12px;
        border: 1px solid #42accd;
        border-radius: 4px;
        background: #ecf7fa;
        font-size: 14px;
        cursor: ponter;

        @media screen and (min-width: ${(props) =>
            props.theme.screenSizes.breakLaptop}) {
          font-size: 16px;
        }
        &:hover {
          background-color: #d3f3fc;
        }
      }

      .unit-price {
        color: #0f0538;
        font-family: "DM Sans";
        font-size: 20px;
        font-weight: 700;
        .month {
          color: #414b64;
          font-size: 11px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-left: 5px;
        }
      }

      .apply-now {
        font-size: 14px;
        padding: 6px 12px;
        border: 1px solid #42accd;
        border-radius: 4px;
        background: #ecf7fa;
        color: inherit;
        text-decoration: none;
        display: flex;
        align-items: center;

        @media screen and (min-width: ${(props) =>
            props.theme.screenSizes.breakLaptop}) {
          font-size: 16px;
        }

        &:hover {
          background-color: #d3f3fc;
        }
      }
    }

    .inner-content {
      height: auto;
      background-color: #f7f9fa;
      width: 100%;
      border-radius: 20px 20px 0 0;
      border-top: 1px solid #d1d1d1;
      margin-top: 220px;
      height: calc(100% - 250px);

      .map-wrapper,
      .tour-wrapper {
        height: calc(100% - 86px);
        background-color: white;
        padding: 18px;
      }
      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakSmall}) {
        top: 315px;

        .tour-wrapper,
        .map-wrapper {
          height: calc(100% - 75px);
        }
      }

      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakLaptop}) {
        height: 90%;
        overflow: hidden;
        width: 95%;
        background-color: white;
        border: 1px solid #d1d1d1;
        border-radius: 20px;
        box-shadow: 4px 4px 8px 0px rgba(115, 115, 115, 0.25),
          0px -8px 16px 0px rgba(217, 217, 217, 0.25);
        margin-top: 30px;

        .tour-wrapper,
        .map-wrapper {
          height: 85%;
        }
      }
    }

    &.expanded {
      height: calc(100% - 130px);
      justify-content: end;
      transition: all 0.4s;
      overflow: visible;
      position: fixed;
      top: 0;
      bottom: 130px;
      z-index: 1000000;
    }

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      &.expanded {
        position: fixed;
        bottom: 90px;
        transition: none;
      }
    }

    @media screen and (max-height: 850px) and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      bottom: 90px !important;
    }

    .scroll-wrapper {
      height: calc(100% - 255px);
      overflow-y: scroll;
      background-color: white;
      ::-webkit-scrollbar {
        display: block;
        width: 6px;
        border-radius: 24px;
      }

      ::-webkit-scrollbar-track {
        background: #f7f9fa;
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        border-radius: 24px;
      }

      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakLaptop}) {
        height: calc(100% - 220px);
      }
    }

    .show-content-innerwrap {
      display: flex;
      flex-direction: column;
      width: 100%;
      background-color: white;
      padding: 0 35px;

      .specials-content {
        text-align: start;
      }
    }

    .show-content-title {
      color: #4e5871;
      font-family: "DM Sans";
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 10px;
      opacity: 0.5;
      text-transform: Uppercase;
      width: 100%;
      text-align: start;
    }

    .close-button {
      position: relative;
      width: 42px;
      height: 42px;
      top: -15px;
      z-index: 100;
      cursor: pointer;

      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakLaptop}) {
        display: none;
      }
    }

    .close-button-laptop {
      display: none;
      position: absolute;
      left: 100%;
      width: 38px;
      height: 38px;
      top: 15px;
      z-index: 100;
      cursor: pointer;
      left: calc(100% - 65px);

      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakLaptop}) {
        display: block;
      }
    }

    .show-content-content {
      margin-bottom: 16px;
      color: #49536c;
      font-family: "DM Sans";
      font-size: 13px;
      font-weight: 400;
      text-align: start;
      ul {
        columns: 2;
        list-style-type: none;
        padding-left: 0px;
        li {
          text-align: start;
          color: #49536c;
          font-family: "DM Sans";
          font-size: 13px;
          font-weight: 400;
        }
        li:before {
          content: "✓";
          padding-right: 10px;
        }
      }
    }

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakSmall}) {
      bottom: 140px;
    }

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      position: fixed;
      top: 130px;
      height: calc(100vh - 290px);
      width: 50%;
      min-width: 846px;
      transform: translateX(-50%);
      left: 50%;
      border-radius: 20px 20px 0 0;
      bottom: 90px;

      .info-container {
        .info-date {
          font-size: 14px;
        }

        .unit-name {
        }

        .floor {
          font-size: 14px;
        }

        .unit-price {
          .month {
            font-size: 14px;
          }
        }
      }

      .show-content-title {
        font-size: 14px;
      }
      .show-content-content {
        ul {
          li {
            font-size: 14px;
          }
        }
      }
    }

    @media screen and (min-height: 900px) and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      top: 165px;
      height: calc(100vh - 360px);
      .show-content-content {
        font-size: 14px;
      }
    }
  }

  @media screen and (max-height: 850px) and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    .unit-name {
      font-size: 20px !important;
    }

    .unit-price {
      font-size: 20px !important;
    }

    .info-date {
      font-size: 14px !important;
    }

    .info-container {
      margin-bottom: 0 !important;
      margin-top: -30px;
    }

    .show-content-title {
      margin-bottom: 5px !important;
    }

    .show-content-content {
      margin-bottom: 10px !important;
    }

    .unit-map {
      margin-bottom: 10px !important;
      .unit-map-button,
      .apply-now {
        font-size: 14px !important;
      }
    }

    .show-content {
      .show-content-title {
        font-size: 16px;
      }

      .show-content-content,
      .show-content-content ul li {
        font-size: 14px;
      }
    }

    .apply-now {
      font-size: 16px;
      padding: 6px 12px;
      border: 1px solid #42accd;
      border-radius: 4px;
      background: #ecf7fa;
      &:hover {
        background-color: #d3f3fc;
      }
    }

    .unit-map-button {
      padding: 6px 12px;
      border: 1px solid #42accd;
      border-radius: 4px;
      background: #ecf7fa;
      display: flex;
      align-items: center;
      font-size: 16px;
      cursor: ponter;
      &:hover {
        background-color: #d3f3fc;
      }
    }
  }
`;

const TabsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: end;
  height: 48px;

  position: sticky;
  position: -webkit-sticky;
  top: -1px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    top: 90px;
  }
  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    top: 0;
    background-color: #f7f9fa;
  }

  &:has(.disabled-tab) {
    justify-content: start;
  }
`;

const Tab = styled.div`
  width: 100%;
  height: 45px;
  font-family: "DM Sans";
  font-size: 15px;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  color:#91979D;
  position: relative;
  bottom: -2px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  cursor: pointer;

  .tab-name {
    text-wrap: nowrap;
  }

  .light-icon {
    display: none;
  }

  &.active-tab {
    height: 48px;
    font-weight: 700;
    background-color: white;
    border-radius: 8px 8px 0 0;

    color: black;
    .dark-icon {
      display: none;
    }

    .light-icon {
      display: block;
    }

    &.disabled-tab {
      width: 33%;
      pointer-events: none;
    }
  }

  &.active-tab {
    color: var(--Primary-Blue);
  }

  &:hover {
    border-bottom: none;
  }

  &.disable-tab {
    pointer-events: none;
    border-bottom: none;
    color: #c4c8cb;
    .dark-icon {
      display: block;
    }

    .light-icon {
      display: none;
    }
  }
`;

const MapWrapper = styled.div`
  height: 100%;
  background: white;
  position: relative;
  border: 1px solid #f1f1f1;
  border-radius: 8px;
  box-shadow: 3px 3px 6px 0px rgba(169, 169, 169, 0.25);
  .carousel-caption {
    color: black;
  }

  .carousel-indicators {
    li {
      background: black;
      border: none;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }

  .carousel-control-next,
  .carousel-control-prev /*, .carousel-indicators */ {
    filter: invert(100%);
  }

  .carousel-control-prev,
  .carousel-control-next {
    align-items: end;
    padding-bottom: 10px;
  }

  .loading-wrapper {
    background: white;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1001;
    border-radius: 8px;
  }
`;

const VirtualTourWrapper = styled.div`
  height: 100%;

  border-radius: 8px;
  border: 1px solid #f1f1f1;
  background: var(--Primary-White, #fff);
  box-shadow: 3px 3px 6px 0px rgba(169, 169, 169, 0.25);
`;
const VirtualTourFrame = styled.iframe`
  height: 100%;
  width: 100%;
  border-radius: 8px 8px 0 0;
  border: none;
   background-color: #f7f9fa;
`;

const Loading = styled.img`
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 99;
  top: 40%;
  transform: translateY(-50%);
  @media screen and (max-width: ${(props) =>
      props.theme.screenSizes.breakXsmall}) {
    width: 50%;
  }
  @media screen and (max-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    width: 50%;
  }
`;

const UnitCarousel = styled(Carousel)`
  display: block;
  height: 455px;
  height: 100%;
  flex: 1;
  align-items: start !important;

  .react-multiple-carousel__arrow {
    bottom: 10px;
    background: #f1f1f1;
  }

  .react-multiple-carousel__arrow:hover {
    background: #fff;
  }

  .react-multiple-carousel__arrow:before {
    color: black;
  }
  .Engrain {
    display: block;
    height: 100% !important;
    svg {
      height: 100%;
    }

    .main {
      height: calc(100% - 60px) !important;
    }
  }

  .react-multi-carousel-list {
    align-items: start;
  }

  .react-multi-carousel-track {
    height: calc(100% - 75px);
  }

`;

function UnitInfo({
  el,
  info,
  hasLike,
  likeUnit,
  showPrice,
  tid,
  selectUnit,
  setExpandedUnit,
  hasMap,
  mapLoading,
  unitMap,
  getUnitsData,
  lang,
  floorplan
}) {
  const [isExpanded, setExpanded] = useState(false);
  const [isLiked, setIsLiked] = useState(!!hasLike);
  const virtualTours = el.virtual_tour && el.virtual_tour.split(",");
  const responsive = {
    allSizes: {
      breakpoint: { max: 5000, min: 0 },
      items: 1,
    },
  };
  let amenities = "";
  if (el.amenities) {
    amenities = (
      <ul>
        {el.amenities.split("\n").map((ell, i) => {
          return <li key={i}>{ell}</li>;
        })}
      </ul>
    );
  }

  const [activeTab, setActiveTab] = useState(tabs.unitList);

  const closeInfo = () => {
    selectUnit(null);
    setExpandedUnit(null);
  };

  const changeTab = (tab) => {
    setActiveTab(tab);
    if (tab === tabs.unitMap) {
      getMaps();
    }
  };
  

  const getMaps = () => {
    getUnitsData({
      gaEvent: "Community Map",
      subType: "text",
      text: "Community Map",
      message: "CommunityMap-CommunityMapConversation",
      type: "text-quicklinks",
      value: "CommunityMap-CommunityMapConversation",
    });
  };

  const data = { virtual_tours: [] };

 const  resetIframes = (slide) => {
  const iframes = document.querySelectorAll('iframe');
    iframes.forEach(iframe => {
      const src = iframe.src;  
      iframe.src = '';         
      iframe.src = src; 
    })

  }

const processedUnitNumber = el.unit_number.includes('-') 
  ? el.unit_number.split('-')[1] 
  : el.unit_number;  

const specificUnitContainer = unitMap.find((unit) =>
  unit.units.some((nestedUnit) => nestedUnit.unit_number === processedUnitNumber)
);

const specificUnit = specificUnitContainer
  ? specificUnitContainer.units.find((nestedUnit) => nestedUnit.unit_number === processedUnitNumber)
  : null;


  const showSpecials = (floorplan, unit) => {
    let input = ""
      if(floorplan.specials) {
        input = floorplan.specials
      }else {
        input = unit.specials
      }

      const regexEn = /<en>(.*?)<\/en>/s;
      const regexEs = /<es>(.*?)<\/es>/s;

      const matchEn = input.match(regexEn);
      const matchEs = input.match(regexEs);

      const wordEn = matchEn ? matchEn[1] : input;
      const wordEs = matchEs ? matchEs[1] : input;
      
     return lang === "English" ? wordEn : wordEs;
  }

  return (
    <UnitInfoWrapper
      className={isExpanded ? "show-content expanded" : "show-content"}
    >
      <img
        className="close-button-laptop"
        src={"/images/close-x.svg"}
        onClick={() => {
          closeInfo();
        }}
      />
      <div className="inner-content">
        <img
          className="close-button"
          src={"/images/close-button.svg"}
          onClick={() => {
            closeInfo();
          }}
        />

        <TabsContainer className="tab-container">
          <Tab
             className={`${activeTab === tabs.unitList && "active-tab"} ${activeTab === tabs.unitList && !el.virtual_tour && hasMap !== 1 && 'disabled-tab'}`}
            onClick={() => changeTab(tabs.unitList)}
          >
            <div className="icons">
              {activeTab === "unitList" && (
                <div className="light-icon">{unitIconLight}</div>
              )}
            </div>
            <div className="tab-name">{translate("Details", language(tid))}</div>
          </Tab>
          {el.virtual_tour ? (
            <Tab
              className={activeTab === tabs.virtualTour && "active-tab"}
              onClick={() => changeTab(tabs.virtualTour)}
            >
              <div className="icons">
                {activeTab === "virtualTour" && (
                  <div className="light-icon">{virtualIconLight}</div>
                )}
              </div>
              <div className="tab-name">
                {translate("Virtual Tours", language(tid))}
              </div>
            </Tab>
          ) : null}
          {hasMap === 1 && (
            <Tab
              className={activeTab === tabs.unitMap && "active-tab"}
              onClick={() => changeTab(tabs.unitMap)}
            >
              <div className="icons">
                {activeTab === "unitMap" && (
                  <div className="light-icon"> {unitMapIconLight}</div>
                )}
              </div>
              <div className="tab-name">{translate("Unit Map", language(tid))}</div>
            </Tab>
          )}
        </TabsContainer>
        {activeTab === tabs.unitList && (
          <React.Fragment>
            <div className="info-container">
              <div className="leftInfo">
                <div className="info-date">
                  {translate("Available:", language(tid))}{" "}
                  {moment(el.availability_date).format("MM/DD/YYYY")}
                </div>
                <div className="unit-name">
                 APT {el.unit_number}
                  <span className="floor">
                    {el.square_feet} {el.square_feet != null ? "sq. ft" : "" }
                  </span>
                </div>
              </div>
              <div className="rightInfo">
                {isLiked ? (
                  <img
                    className="likeHeart"
                    src={"/images/Heart-fill.svg"}
                    alt="like"
                    onClick={() => {
                      setIsLiked(!isLiked);
                      likeUnit(el);
                    }}
                  />
                ) : (
                  <img
                    className="likeHeart"
                    src={"/images/Heart-empty.svg"}
                    alt="like"
                    onClick={() => {
                      setIsLiked(!isLiked);
                      likeUnit(el);
                    }}
                  />
                )}
                {showPrice && (
                  <div className="unit-price">
                    $ {el.rent_rate.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    <span className="month">/mo</span>
                  </div>
                )}
              </div>
            </div>
            <div className="apply-wrapper">
              { el.apply_now &&
                <a className="apply-now" href={el.apply_now} target="_blank">
                  {translate("Apply Now", language(tid))} {applyNowIcon}
                </a>
              }
            </div>

            <div className="scroll-wrapper">
              <div className="show-content-innerwrap">
               
                {(floorplan.specials || el.specials) && (
                  <>
                   <div className="show-content-title">
                  {" "}
                  {translate("SPECIALS", language(tid))}
                  </div>
                  <div className="show-content-content specials-content">
                    {showSpecials(floorplan, el)}
                  </div>
                  </>
                ) }
              </div>

              <div className="show-content-innerwrap amenities-wrapper">
                <div className="show-content-title">
                  {" "}
                  {translate("AMENITIES", language(tid))}
                </div>
                {el.amenities ? (
                  <div className="show-content-content">
                    {el.amenities && amenities}
                  </div>
                ) : (
                  <div className="show-content-content">
                   {translate("No amenities data provided", language(tid))}
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        )}
        {activeTab === tabs.unitMap && (
          <div className="map-wrapper">
            <MapWrapper>
              {mapLoading && (
                <div className="loading-wrapper">
                  <Loading
                    alt="loading search"
                    src={window.location.origin + "/images/loading-search.gif"}
                  />
                </div>
              )}
            <UnitCarousel className="UnitCarousel" responsive={responsive}>
              {specificUnit ? (
                <EngrainMap
                  data={specificUnitContainer}
                  key={specificUnitContainer.unit_number}
                  activeUnit={specificUnit.unit_number}
                  floorId={specificUnitContainer.floorId}
                  info={'specificUnit'}
                />
              ) : (
                <div>Unit not found</div>
              )}
            </UnitCarousel>
            </MapWrapper>
          </div>
        )}
        {activeTab === tabs.virtualTour && (
          <div className="tour-wrapper">
            <VirtualTourWrapper>
              <UnitCarousel  className="UnitCarousel" responsive={responsive} beforeChange={(nextSlide, { currentSlide, onMove }) => resetIframes(currentSlide)}>
                {virtualTours.map((el, key) => {
                  return (
                    <VirtualTourFrame
                      src={el}
                      key={key}
                    ></VirtualTourFrame>
                  );
                })}
              </UnitCarousel>
            </VirtualTourWrapper>
          </div>
        )}
      </div>
    </UnitInfoWrapper>
  );
}

export default UnitInfo;
